import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmBoxModel } from './confirm-box.model';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';
import { ActiveService } from '@app/features/active/services';

@Component({
  selector: 'app-confirm-box',
  templateUrl: './confirm-box.component.html',
  styleUrls: ['./confirm-box.component.scss']
})

export class ConfirmBoxComponent implements OnInit {
  public model: ConfirmBoxModel = new ConfirmBoxModel();
  public ConfirmBoxDefaultButton: typeof ConfirmBoxDefaultButton = ConfirmBoxDefaultButton;


  @ViewChild('confirmButton', { static: true }) confirmButton: ElementRef;
  @ViewChild('cancelButton', { static: true }) cancelButton: ElementRef;

  onClick(confirmed: boolean): void {
    if (confirmed == true) {
      if (this.model.onConfirm != null) this.model.onConfirm();
      this.dialogRef.close(true);
    } else {
      if (this.model.onCancel != null) this.model.onCancel();
      this.dialogRef.close(false)
    }
  }

  constructor(public dialogRef: MatDialogRef<ConfirmBoxComponent>, @Inject(MAT_DIALOG_DATA) public data: ConfirmBoxModel,
  private sharedVariable : SharedVariable,private activeService: ActiveService) { }

  ngOnInit(): void {
    this.model = this.data;
    if (this.data.showCancelButton == undefined || this.data.showCancelButton == null) this.model.showCancelButton = true;
  }

  isNull(value) {
    if (typeof value == 'undefined' || value == null) return true; else return false;
  }
}

export enum ConfirmBoxColor {
  error = '#f24c4c',
  warn = '#F2A51A',
  info = '#5AB8CA'
}

export enum ConfirmBoxDefaultButton {
  confirmar,
  cancelar
}
